<template>
  <v-toolbar
    app
    dark
    :flat="!isScrolling"
    :color="!isScrolling ? 'transparent' : 'secondary darken-2'"
    v-scroll="onScroll"
  >
    <img
      v-show="$vuetify.breakpoint.smAndUp"
      src="static/deakin-logo.png"
      width="300px"
    >
    <v-spacer />
    <v-toolbar-items v-if="$vuetify.breakpoint.mdAndUp">
      <v-btn
        :active-class="!isScrolling ? 'primary--text' : undefined"
        flat
        v-for="(item, i) in items"
        :key="i"
        :to="item.to"
      >
        <span v-text="item.text" />
      </v-btn>
      <v-tooltip bottom>
        <v-btn 
          slot="activator"
          flat 
          icon
          to="/login"
          @click="logout">
          <v-icon small>logout</v-icon>
        </v-btn>
        <span>Logout</span>
      </v-tooltip>
      
    </v-toolbar-items>
    <v-btn 
      v-else 
      icon 
      @click="toggleDrawer">
      <v-icon>menu</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  data: () => ({
    isScrolling: false
  }),

  computed: {
    items() {
      return this.$store.getters.getRoutes;
    }
  },

  methods: {
    ...mapMutations(["toggleDrawer"]),
    onScroll() {
      this.isScrolling =
        (window.pageYOffset || document.documentElement.scrollTop || 0) > 100;
    },
    logout() {
      this.$store.dispatch("logout");
    }
  }
};
</script>
